import API_BASE_URL from './baseUrl';
const getCsrfToken = () => {
    if (typeof document === 'undefined') {
        return null;
    }
    const match = document.cookie.match(/(?:^|;\s*)_csrfToken=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
};
const request = async (path, init) => {
    const method = init?.method?.toUpperCase() ?? 'GET';
    const csrfToken = method === 'GET' || method === 'HEAD' ? null : getCsrfToken();
    const response = await fetch(`${API_BASE_URL}${path}`, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(csrfToken ? { 'x-csrf-token': csrfToken } : {}),
            ...init?.headers,
        },
        ...init,
    });
    if (!response.ok) {
        let message = '';
        try {
            const payload = await response.json();
            message = typeof payload?.message === 'string' ? payload.message.trim() : '';
        }
        catch (_error) {
            // Preserve the status fallback when the server did not return JSON.
        }
        throw new Error(message || `Notification request failed: ${response.status}`);
    }
    return response.json();
};
export const notificationsApi = {
    preferences: () => request('/notifications/preferences'),
    updatePreferences: (preferences) => request('/notifications/preferences', { method: 'PUT', body: JSON.stringify({ preferences }) }),
    outbox: (params) => {
        const query = new URLSearchParams();
        if (params?.channel)
            query.set('channel', params.channel);
        if (params?.status)
            query.set('status', params.status);
        if (typeof params?.limit === 'number')
            query.set('limit', String(params.limit));
        return request(`/notifications/outbox${query.size ? `?${query}` : ''}`);
    },
    retryDelivery: (id) => request(`/notifications/outbox/${encodeURIComponent(id)}/retry`, { method: 'POST', body: JSON.stringify({}) }),
    list: (params) => {
        const query = new URLSearchParams();
        if (typeof params?.page === 'number') {
            query.set('page', String(params.page));
        }
        if (typeof params?.limit === 'number') {
            query.set('limit', String(params.limit));
        }
        if (params?.unreadOnly) {
            query.set('unreadOnly', '1');
        }
        const suffix = query.toString();
        return request(`/notifications${suffix ? `?${suffix}` : ''}`);
    },
    summary: () => request('/notifications/summary'),
    markRead: (id) => request(`/notifications/${encodeURIComponent(id)}/read`, { method: 'POST', body: JSON.stringify({}) }),
    markAllRead: () => request('/notifications/read-all', { method: 'POST', body: JSON.stringify({}) }),
    setSubscription: (payload) => request('/notifications/subscriptions', {
        method: 'PUT',
        body: JSON.stringify(payload),
    }),
    getSubscription: (objectName, id, objectType) => {
        const query = new URLSearchParams();
        if (typeof objectType === 'number') {
            query.set('objectType', String(objectType));
        }
        const suffix = query.toString();
        return request(`/notifications/subscriptions/${encodeURIComponent(objectName)}/${encodeURIComponent(id)}${suffix ? `?${suffix}` : ''}`);
    },
};
export default notificationsApi;
